import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Header from './components/Common/Header/Header';
import Footer from './components/Common/Footer/Footer';
import GalleryComponent from './components/Gallery/GalleryComponent';
import Banner1 from './components/Banner1/Banner1';
import Tours from './components/Tours/Tours';
import About from './components/About us/About';
import Contact from './components/Contact/Contact';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from "./components/Privacy/PrivacyPolicy";
import TermsAndConditions from "./components/TermsandCondition/TermsAndConditions";






function App() {
  const location = useLocation();

  return (
    <>
     <ScrollToTop /> {/* Smoothly scrolls to top on route change */}
      <Header />

   

      {/* Conditionally render Banner1 for all pages except Home */}
      {location.pathname !== '/' && <Banner1 />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/gallery" element={<GalleryComponent />} />
        {/* <Route path="/tour" element={<TravelThemes />} /> */}
        <Route path="/tours" element={<Tours />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/terms-and-conditions" element={<TermsAndConditions />} />

 
      </Routes>

      <Footer />
    </>
  );
}

export default App;
